import { ComponentStyleConfig } from '@chakra-ui/react';

export const ProfileImage: ComponentStyleConfig = {
  parts: ['container', 'avatar', 'editOverlay'],
  baseStyle: {
    container: {
      position: 'relative',
      minWidth: 128,
      width: 128,
      height: 128,
      backgroundColor: 'white',
      alignItems: 'flex-end',
      justifyContent: 'center',
      borderRadius: '50%',
      cursor: 'pointer',
      overflow: 'hidden',
      _hover: {
        ' .editOverlay': {
          opacity: 0.8,
        },
      },
    },
    editOverlay: {
      opacity: 0,
      justifyContent: 'center',
      paddingTop: 1,
      backgroundColor: 'surface1',
      position: 'absolute',
      bottom: -27,
      left: 0,
      width: '100%',
      height: 57,
      borderBottomLeftRadius: '50%',
      borderBottomRightRadius: '50%',
    },
  },
};
